// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"6dc64ca7","17":"240e01a1","229":"c33890ad","281":"717a08ac","370":"7b34ba76","409":"18089ae0","477":"efd57186","513":"fdb54478","547":"37ceb743","768":"eada3e3b","856":"5bed1878","872":"5812a4eb","978":"b7d5d347"}[chunkId] + ".chunk.js";
};